import { APPOINTMENT_STATUSES } from 'constants/AppointmentConstants';

/** @param {(...unknown) => import('modules/global/generic.types').Action<unknown>} action */
export const actionFormatter = action =>
  /**
   * @param {unknown} data
   * @param {Object} meta
   * @param {import('modules/global/generic.types').ActionRequest<unknown>} parentAction
   */
  (data, meta, parentAction) => {
    const { id } = parentAction.payload;
    return action(id, data, meta);
  };

/**
 * @param {import('modules/global/typing/enums/appointments.enum').AppointmentStatusEnum} status
 * @param {boolean} isSuccess
 * @returns {string}
 */
export const patchStatusMessageId = (status, isSuccess = true) => {
  let statusId = 'update_appointment';
  if (status === APPOINTMENT_STATUSES.ENDED) {
    statusId = 'end_appointment';
  }
  return `page.fiche.notification.${statusId}.${isSuccess ? 'success' : 'failure'}`;
};
